import React from 'react';
import PropTypes from 'prop-types';
import styles from './paperBasedInteraction.scss';
import customFieldsService from '../../../../services/CustomFieldsService';
import LoadTracker from '../../../../services/LoadTracker';

const PB_SYMBOL = '.';
const SYMBOL_MULTIPLIER_SHORT = 9;
const SYMBOL_MULTIPLIER_MEDIUM = 15;

class PaperBasedInteractionInput extends React.PureComponent {
    static propTypes = {
        isShortSize: PropTypes.bool,
        position: PropTypes.object,
        orderNumber: PropTypes.string,
        questionModel: PropTypes.object,
        identifier: PropTypes.string,
        reportGapReady: PropTypes.func,
        handleInputReady: PropTypes.func,
    };

    constructor(props) {
        super(props);
        if (props.reportGapReady && props.identifier) {
            this.readyTracker = new LoadTracker(props.reportGapReady, `Gap ${props.identifier}`);
            this.readyTracker.setAllItemsAdded();
        }
    }

    componentDidMount() {
        if (this.props.handleInputReady) {
            this.props.handleInputReady(true);
        }
    }

    render() {
        const { isShortSize, position, orderNumber, questionModel } = this.props;

        const symbolMultiplier = isShortSize ? SYMBOL_MULTIPLIER_SHORT : SYMBOL_MULTIPLIER_MEDIUM;
        const isShortAnswerQuestion = questionModel && customFieldsService.isShortAnswerQuestion(questionModel);

        const classNames = [styles.paperBasedInput];
        const placeholderClassNames = ['pb-input-placeholder'];

        if (isShortAnswerQuestion) {
            classNames.push(styles.shortAnswerQuestion);
            placeholderClassNames.push(styles.pbNewLinePlaceholder);
        }

        let styleRules = {};
        if (position && position.left && position.top) {
            styleRules = {
                left: `${position.left}px`,
                top: `${position.top}px`,
                position: 'absolute',
            };
        }

        return (
            <span className={classNames.join(' ')} style={styleRules}>
                {
                    orderNumber
                        ? <span className="pb-input-number">{orderNumber}</span>
                        : null
                }
                <span className={placeholderClassNames.join(' ')}>
                    {PB_SYMBOL.repeat(symbolMultiplier)}
                </span>
            </span>
        );
    }
}

export default PaperBasedInteractionInput;
